<template>
  <div class="py-2 px-3 sm:px-0">
    <van-checkbox
        v-if="product.has_diff_power_options"
        v-model="hasDifferPowerOptions"
        @change="$emit('reset')"
    >{{ $t("product.different_sizes") }}
    </van-checkbox>

    <div class="pt-4">
      <div class="flex items-center gap-2 md:gap-4">
        <p v-if="product.has_diff_power_options" class="font-bold w-full">
          {{ $t("product.power_sight") }}
        </p>

        <div class="w-full">
          <span v-if="hasDifferPowerOptions" class="text-center block">
            {{ $t("product.right_title") }}</span
          >
          <slot name="default-option"/>
        </div>

        <div v-if="hasDifferPowerOptions" class="w-full">
          <span class="text-center block">
            {{ $t("product.left_title") }}</span
          >
          <slot name="second-option"/>
        </div>
      </div>

      <div class="flex items-center gap-2 md:gap-4 mt-2 md:mt-0">
        <p v-if="product.has_diff_power_options" class="font-bold w-full">
          {{ $t("product.number_of_pieces") }}
        </p>
        <counter
            v-if="product.has_diff_power_options"
            :value="selectedOptionsAttributes.defaultOptionQuantity"
            class="w-full"
            @decrement="selectedOptionsAttributes.defaultOptionQuantity--"
            @increment="selectedOptionsAttributes.defaultOptionQuantity++"
        />

        <counter
            v-if="hasDifferPowerOptions"
            :value="selectedOptionsAttributes.secondaryOptionQuantity"
            class="w-full"
            @decrement="selectedOptionsAttributes.secondaryOptionQuantity--"
            @increment="selectedOptionsAttributes.secondaryOptionQuantity++"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import {useCartStore} from "@/store/cart";
import Counter from "@/components/product/Counter";

const props = defineProps({
  product: {
    type: Object,
    default: () => {
    },
  },
});

const {selectedOptionsAttributes, hasDifferPowerOptions} = storeToRefs(
    useCartStore()
);
hasDifferPowerOptions.value = props.product.has_diff_power_options;
</script>
